import AssetUserImport from "./assets/definitions/user/AssetUserImport"
import OktaImport from "./assets/definitions/okta/OktaImport"
import AssetGenericmport from "./assets/definitions/generic/AssetGenericmport"

//Register the wizard here, it is a list of wizard definitions.
export const wizardRegistry = [AssetUserImport,OktaImport,AssetGenericmport]
//Add categories here, the id will be matched to the category property of the wizard tutorial.
export const wizardCategories = [
    {
        id:"JSM_ASSET_IMPORT",
        title: "Jira Service Management - Assets Import(s)",
        description:"Import Assets from external sources."
    } 
]

export const getCurrentWizardPage = (currentWizardId, currentPage) => {
    const wizard = wizardRegistry.find((w) => w.id === currentWizardId);
    const currentPageContent = wizard?.pages[currentPage-1]?.content;
    return currentPageContent || "PAGE NOT FOUND";
};
export const getCurrentWizardValidateFunction = (currentWizardId, currentPage) => {
    const wizard = wizardRegistry.find((w) => w.id === currentWizardId);
    const validateFunction = wizard?.pages[currentPage-1]?.validate;
    return validateFunction || (() => true);
};